import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { EumEditor } from '@appbase/components/editor'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'

@Component({
  components: { EumEditor },
  computed: mapGetters({
    userCurrent: accountTypes.CURRENT,
  }),
})
export default class WriteBody extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: String, default: '' }) value!: string

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  userCurrent!: account.TCurrent

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  tinyopts: eumEditor.EditorOptions = {
    menubar: false,
    inline: false,
    height: '100%',
  }

  dext5opts: editor.dext5.DEXT5Config = {
    EditorBorder: '0',
    Lang: 'ko_KR',
  }

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  emitInput() {
    const editor: editor.IEditorProxy = this.$refs.editor as any
    const body = editor.getEditor().getBodyValue()
    this.$emit('input', body);
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  created() {
    this.dext5opts.Lang = this.userCurrent.userConfig.language
  }
}
